export const DEFAULT_CATEGORY_IMAGE =
  'http://acorn-ux.atd.ct.lodgenet.com/api/static/images/default_gr_category_image.jpg';

export const PRODUCTS_KEYS = Object.freeze({
  BRANDING: 'branding',
  GROUP_CHANNEL: 'group_channel',
  GUEST_REQUEST: 'guest_request',
  HAPPENINGS_CHANNEL: 'happenings_channel',
  HOTEL_DIRECTORY: 'hotel_directory',
  IRD: 'ird',
  REPORTING: 'reporting',
  STAYCAST: 'staycast',
});
